import { defineVariants } from "@/runtime/style-engine/define-variants";

export const groupClasses = defineVariants({
  base: "inline-flex items-center",
  variants: {
    orientation: {
      horizontal: "flex-row",
      vertical: "flex-col",
    },
  },
  defaults: {
    orientation: "horizontal",
  },
});
